import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";

import {
    DndContext,
    PointerSensor,
    closestCenter,
    useSensor,
    useSensors,
} from "@dnd-kit/core";
import {
    SortableContext,
    verticalListSortingStrategy,
} from "@dnd-kit/sortable";

import { ISponsor } from "@src/types/api";

import { selectSponsors } from "@features/global/globalSlice";

import { useAppSelector } from "@hooks/reduxHooks";

import SortableRow from "@SiteManagement/Advertisers/components/SortableRow";
import useAdvertisers from "@SiteManagement/Advertisers/hooks/useAdvertisers";

const AdvertisersTable = (): React.JSX.Element => {
    const sponsorsFromState = useAppSelector(selectSponsors);
    const [sponsors, setSponsors] =
        useState<Array<ISponsor>>(sponsorsFromState);
    const { handleDragEnd } = useAdvertisers(setSponsors);

    // Initialize local state with sponsors from Redux, sorted by sortOrder
    useEffect(() => {
        const sortedSponsors = [...sponsorsFromState].sort(
            (a, b) => a.sortOrder - b.sortOrder,
        );
        setSponsors(sortedSponsors);
    }, [sponsorsFromState]);

    const sensors = useSensors(useSensor(PointerSensor));

    return (
        <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
        >
            <Table className="w-75 mx-auto advertisersTable text-center">
                <thead>
                    <tr>
                        <th></th>
                        <th>Sort Order</th>
                        <th>Logo</th>
                        <th>Name</th>
                        <th></th>
                    </tr>
                </thead>
                <SortableContext
                    items={sponsors.map(s => s.id)}
                    strategy={verticalListSortingStrategy}
                >
                    <tbody>
                        {sponsors.map(sponsor => (
                            <SortableRow key={sponsor.id} sponsor={sponsor} />
                        ))}
                    </tbody>
                </SortableContext>
            </Table>
        </DndContext>
    );
};

export default AdvertisersTable;
